import { ApiRoutingUtils } from '@/Routing';
import { BinaryResponse } from '@/Api';
import { DocumentTemplatePrintType } from '@/Models';
import { rest } from '@/Api/Rest';
import { DocumentTemplateType } from '@/Enums/DocumentTemplateType';
import { DeleteDocumentTemplateResponse } from './Responses/DeleteDocumentTemplateResponse';
import { GetTemplatesCreatedByMarketUserRequest } from './Requests/GetTemplatesCreatedByMarketUserRequest';
import { GetTemplatesCreatedByMarketUserResponse } from './Responses/GetTemplatesCreatedByMarketUserResponse';
import { PrintUnionPdfFilesRequest } from './Requests/PrintUnionPdfFilesRequest';
import { GetTemplateByTypeRequest } from './Requests/GetTemplateByTypeRequest';
import { GetTemplateByTypeResponse } from './Responses/GetTemplateByTypeResponse';
import { GetAllDocumentTemplateResponse } from './Responses/GetAllDocumentTemplateResponse';
import { UpdateDocumentTemplateRequest } from './Requests/UpdateDocumentTemplateRequest';
import { UpdateDocumentTemplateResponse } from './Responses/UpdateDocumentTemplateResponse';
import { CopyTemplateRequest } from './Requests/CopyTemplateRequest';
import { CopyTemplateResponse } from './Responses/CopyTemplateResponse';
import { RestoreTemplateRequest } from './Requests/RestoreTemplateRequest';
import { RestoreTemplateResponse } from './Responses/RestoreTemplateResponse';
import { PrinterSettingsResponse } from './Responses/PrinterSettingsResponse';
import { PrintUnionDocumentRequest } from './Requests/PrintUnionDocumentRequest';

const url = ApiRoutingUtils.createUrl('document-templates');

async function getAllDocumentTemplates(
  type: DocumentTemplateType,
  printType?: DocumentTemplatePrintType,
): Promise<GetAllDocumentTemplateResponse> {
  return rest.get(url, { type: type, printType: printType });
}

async function getTemplateByType(request: GetTemplateByTypeRequest): Promise<GetTemplateByTypeResponse> {
  return rest.post(`${url}/template-by-type`, request);
}

async function getTemplatesCreatedByMarketUser(
  request: GetTemplatesCreatedByMarketUserRequest,
): Promise<GetTemplatesCreatedByMarketUserResponse> {
  return rest.get(`${url}/created-by-market-user`, request);
}

async function updateDocumentTemplate(request: UpdateDocumentTemplateRequest): Promise<UpdateDocumentTemplateResponse> {
  return rest.put(`${url}`, request);
}

async function deleteDocumentTemplate(guid: string): Promise<DeleteDocumentTemplateResponse> {
  return rest.delete(`${url}/${guid}`, null);
}

async function copyDocumentTemplate(request: CopyTemplateRequest): Promise<CopyTemplateResponse> {
  return rest.post(`${url}/copy`, request);
}

async function restoreDocumentTemplate(request: RestoreTemplateRequest): Promise<RestoreTemplateResponse> {
  return rest.post(`${url}/restore`, request);
}

async function printerSettings(guid: string): Promise<PrinterSettingsResponse> {
  return rest.get(`${url}/printer-settings/${guid}`);
}

async function printDocument(guid: string, orderId: number): Promise<BinaryResponse> {
  return rest.getBinary(`${url}/print/${guid}/${orderId}`);
}

async function printUnionDocument(guid: string, request: PrintUnionDocumentRequest): Promise<BinaryResponse> {
  return rest.postBinary(`${url}/print/${guid}`, request);
}

async function printUnionPdfFiles(request: PrintUnionPdfFilesRequest): Promise<BinaryResponse> {
  return rest.postBinary(`${url}/print-union-pdf-files`, request);
}

export const DocumentTemplateApi = {
  getAllDocumentTemplates,
  getTemplateByType,
  getTemplatesCreatedByMarketUser,
  updateDocumentTemplate,
  deleteDocumentTemplate,
  restoreDocumentTemplate,
  copyDocumentTemplate,
  printerSettings,
  printDocument,
  printUnionDocument,
  printUnionPdfFiles,
};
